module.exports = __webpack_public_path__ + "img/contenedor6.4be5d8b4.png";